import {useContext, useEffect, useState} from "react";
import {Offcanvas} from "react-bootstrap";
import EditPayee from "./EditPayee";
import TransactionsTable from "./TransactionsTable";
import TransactionOverlay from "./TransactionOverlay";
import RefreshContext from "../RefreshContext";
import withParams from "../lib/withParams";
import apiClient from "../lib/apiClient";


export default function PayeeOverlay({payee, onClose, dataViewId, accountId}) {
  const [isEditing, setIsEditing] = useState(false);
  const [transactions, setTransactions] = useState(null);
  const [transaction, setTransaction] = useState(null);
  const [sortOrder, setSortOrder] = useState("date");

  const {refreshKey} = useContext(RefreshContext);

  // FIXME: when payee or payee.id is null, we need to fetch the uncategorized transactions
  const {id, regex, name, category} = payee || {};
  const path = payee?.id ?
    withParams(`/api/payees/${id}/transactions`, {dataViewId, accountId, sortOrder}) :
    withParams("/api/transactions", {dataViewId, accountId, sortOrder}) + "&uncategorized=true";

  console.log("Path", path);
  useEffect(() => {
    const fetchTransactions = async () => {
      setTransactions(null);
      if (!path) return;

      const {data} = await apiClient.get(path);

      setTransactions(data);
    };

    fetchTransactions();
  }, [path, refreshKey]);

  return <>
    <Offcanvas show={payee && !transaction} backdrop scroll placement="end"
               onHide={onClose} style={{width: "800px", overflowY: 'auto'}}>
      <Offcanvas.Header className="d-flex align-items-baseline" closeButton>
        {payee?.id && <>
          <h3>{name}</h3>
          <span className="ms-2">
            {category}
          </span>
          <div className="flex-grow-1"/>
          <button className={"btn btn-link"} onClick={() => setIsEditing(true)}>
            Edit
          </button>
        </>}
        {!payee?.id && <>
          <h3>Uncategorized Transactions</h3>
        </>}
      </Offcanvas.Header>
      <div className="p-3">
        {transactions === null && <div>Loading...</div>}
        {transactions?.length > 0 && <TransactionsTable withTotal
                                                        onClickTransaction={setTransaction}
                                                        sortColumn={sortOrder}
                                                        onClickAmount={() => {setSortOrder("amount")}}
                                                        onClickDate={() => {setSortOrder("date")}}
                                                        columns={["account_name"]}
                                                        transactions={transactions}/>}
        {transactions?.length === 0 && <div>
          <p>No transactions matching <code>{regex}</code> for {name}.</p>
        </div>}
      </div>

    </Offcanvas>
    {payee && isEditing && <EditPayee payee={payee} onHide={() => setIsEditing(false)}/>}
    {transaction && <TransactionOverlay transactionId={transaction.id} onClose={() => setTransaction(null)}/>}
  </>
}

